export const generateUniqueString = () => Math.random().toString(36).substr(2, 9);
